<section class="how-it-works" aria-labelledby="how-it-works-title">
  <div class="how-it-works__inner">
    <p class="how-it-works__eyebrow">How it works</p>

    <h2 id="how-it-works-title" class="how-it-works__title">
      From model to meaningful results
    </h2>

    <p class="how-it-works__text">
      A clear evaluation journey designed to keep both model and data private.
    </p>
  </div>

  <ol class="how-it-works__steps">
    <li class="how-it-works__step">
      <span class="how-it-works__step-number" aria-hidden="true">01</span>
      <h3 class="how-it-works__step-title">Choose a benchmarking dataset</h3>
      <p class="how-it-works__step-text">
        Browse available benchmarking datasets and review their documentation.
      </p>
    </li>

    <li class="how-it-works__step">
      <span class="how-it-works__step-number" aria-hidden="true">02</span>
      <h3 class="how-it-works__step-title">Upload your AI model</h3>
      <p class="how-it-works__step-text">
        Submit your trained model securely for evaluation.
      </p>
    </li>

    <li class="how-it-works__step">
      <span class="how-it-works__step-number" aria-hidden="true">03</span>
      <h3 class="how-it-works__step-title">Secure evaluation</h3>
      <p class="how-it-works__step-text">
        Your model is evaluated within a confidential computing environment.
      </p>
    </li>

    <li class="how-it-works__step">
      <span class="how-it-works__step-number" aria-hidden="true">04</span>
      <h3 class="how-it-works__step-title">View results</h3>
      <p class="how-it-works__step-text">
        Receive evaluation metrics and optionally publish your results to the leaderboard.
      </p>
    </li>
  </ol>
</section>
